import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import conciergeApiClient from 'Services/Apis/Concierge/conciergeApiClient';

export const getRequestTypeThunk = createAsyncThunk(
    `RequestTypeSlicer/getRequestTypeThunk`,
    async (_, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
        };

        const { data } = await conciergeApiClient.get('RedemptionWorkflow',
            {
                headers
            });
        return data;
    }
);

const initialState = {
    dataRequestType: [],
    loadingRequestType: false,
    errorRequestType: false,
};

const RequestTypeSlicer = createSlice({
    name: 'requestType',
    initialState,
    reducers: {
        resetDataRequestType: (state) => {
            state.dataRequestType = [];
            state.loadingRequestType = false;
            state.errorRequestType = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getRequestTypeThunk.pending, (state) => {
            state.dataRequestType = [];
            state.loadingRequestType = true;
            state.errorRequestType = false;
        });
        builder.addCase(getRequestTypeThunk.fulfilled, (state, action) => {
            state.dataRequestType = action.payload;
            state.loadingRequestType = false;
            state.errorRequestType = false;
        });
        builder.addCase(getRequestTypeThunk.rejected, (state) => {
            state.dataRequestType = [];
            state.loadingRequestType = false;
            state.errorRequestType = true;
        });
    },
});

export const { resetDataRequestType } = RequestTypeSlicer.actions;
export default RequestTypeSlicer.reducer;